import { AxiosInstance } from "axios";
import axios from "axios";
import { APIResponse } from "@/customTypes/NetworkTypes";
import NetworkUtil from "@/projectUtils/NetworkUtil";
import { apiEndpoints, axiosRequestConfig } from "./axiosConfig/AxiosServiceConstants";
import { iShiprocketDTO } from "@/redux/Shiprocket/Types";
import { promptLoginOnExpiredToken } from "../commonInterceptors/AxiosResponseInterceptors";

const apiServer = axios.create(axiosRequestConfig);

apiServer.interceptors.response.use(
  (response) => response,
  promptLoginOnExpiredToken
);

const createShiprocketService = (apiServer: AxiosInstance) => {
  const getToken = (): string | null => {
    return localStorage.getItem("userToken");
  };

  const DataShiprocketUser = async (data: iShiprocketDTO): Promise<APIResponse<any> | null> => {
    let result = null;
    const token = getToken();

    await apiServer
      .post(apiEndpoints.shiprocket.addShiprocketUser(), data, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      })
      .then(
        (value) => {
          result = NetworkUtil.buildResult<any>(null, value.status, null, value.data);
        },
        (reason) => {
          const { response } = reason;
          const { status, data } = response;
          result = NetworkUtil.buildResult<null>(data, status, data, null);
        }
      )
      .catch((error) => {
        throw error;
      });

    return result;
  };

  const getShiprocketUser = async (vendorId: string | number): Promise<APIResponse<any> | null> => {
    let result = null;
    const token = getToken();

    await apiServer
      .get(apiEndpoints.shiprocket.getShiprocketUser(vendorId), {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
      .then(
        (value) => {
          result = NetworkUtil.buildResult<any>(null, value.status, null, value.data);
        },
        (reason) => {
          const { response } = reason;
          const { status, data } = response;
          result = NetworkUtil.buildResult<null>(data, status, data, null);
        }
      )
      .catch((error) => {
        throw error;
      });

    return result;
  };

 const createShipRocket = async (
  vendorId: string | number,
  orderPayload: object
): Promise<APIResponse<any> | null> => {
  let result = null;
  const token = getToken();

  await apiServer
    .post(
      apiEndpoints.shiprocket.createShipRocket(String(vendorId)), // vendorId in URL path
      orderPayload, // order data in request body
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
    .then(
      (value) => {
        result = NetworkUtil.buildResult<any>(null, value.status, null, value.data);
      },
      (reason) => {
        const { response } = reason;
        const { status, data } = response;
        result = NetworkUtil.buildResult<null>(data, status, data, null);
      }
    )
    .catch((error) => {
      throw error;
    });

  return result;
};



 const getShipRocketDetail = async (orderId: string): Promise<APIResponse<any> | null> => {
  const token = getToken();

  try {
    const response = await apiServer.get(
      apiEndpoints.shiprocket.getShipRocketDetail(orderId), // should return `shiprocket/get-order-details/${orderId}`
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return NetworkUtil.buildResult<any>(null, response.status, null, response.data);
  } catch (error: any) {
    const { response } = error;
    const { status, data } = response;
    return NetworkUtil.buildResult<null>(data, status, data, null);
  }
};

const shipRocketOrderTrack = async (orderId: string): Promise<APIResponse<any> | null> => {
  const token = getToken();

  try {
    const response = await apiServer.get(
      apiEndpoints.shiprocket.shipRocketOrderTrack(orderId), // should return `shiprocket/get-order-details/${orderId}`
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return NetworkUtil.buildResult<any>(null, response.status, null, response.data);
  } catch (error: any) {
    const { response } = error;
    const { status, data } = response;
    return NetworkUtil.buildResult<null>(data, status, data, null);
  }
};

  return {
    DataShiprocketUser,
    getShiprocketUser,
    createShipRocket,
    getShipRocketDetail,
    shipRocketOrderTrack,
  };
};

export const shiprocketService = createShiprocketService(apiServer);

export default createShiprocketService;
